import { ChangeDetectorRef, Component, EventEmitter, HostListener, NgZone, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import * as myGlobals from '../../shared/globalcontants'; // CONSTANT FILE ADD ANY CONSTANT VALUE
import { SearchHistoryEntity, SearchHistoryPostEntity } from '../models/Transactions/SearchHistoryEntity';
import { CommonService } from '../services/common.service';
import * as appApiResources from '../../shared/globalcontants';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PrevilegeAuthorizationService } from 'src/app/authorization/services/privilege-authorization.service';
import { RequestService } from '../services/RequestServices/Request-Service';
import { APIServiceProviderService } from '../services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { BarcodAutoGeneratorServiceService } from '../services/barcod-auto-generator-service.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { InventoryService } from 'src/app/inventory/inventory.service';
import { MultilanguageService } from '../services/multilanguage.service';
import { ServersideutoCompleteComponent } from '../component/autocomplete-serverside/autocomplete-serverside.component';
import { CSharpRequestService } from '../services/csharp-request.service';
import * as SearchSource from '../../../assets/json/item-source.json';
import { InventoryStatusSourceDetails } from '../models/Transactions/InventoryHeadEntity';
import {  InventoryLookupCollection, InventoryLookUpPost, LookupConfigurationV2 } from '../models/Inventory/InventoryLookUpEntity';
import { ISubscription } from 'rxjs/Subscription';
import { debounceTime } from 'rxjs/operators';
import { FieldConfig } from '../dynamicform/models/field-config.interface';
import { Validators } from '@angular/forms';
import { DynamicFormComponent } from '../dynamicform/dynamic-form/dynamic-form.component';
import { PopupComponent } from '../popup/popup.component';
import { MatDialog } from '@angular/material/dialog';
import { GlobalConversionService } from '../services/GlobalMethodService/GlobalConversion-Service';
import { FacadeService } from 'src/app/receiving/shared/services/facade.service';
import { TransferService } from 'src/app/transfers/transfer.service';
import { SpoilageService } from 'src/app/spoilage/spoilage.service';
import { PurchaseOrderService } from 'src/app/purchase-order/purchase-order.service';
import { IngredientsBarcodeEntity } from '../models/Inventory/InventoryEntity';
import { SearchByCategoryId } from '../../shared/globalcontants';
import { CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';
import { DecimalFormatterPipe } from '../pipes/decimal-formatter.pipe';
@Component({
    selector: 'app-barcode-mapping',
    templateUrl: './barcode-mapping.component.html',
    styleUrls: ['./barcode-mapping.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        '(document:click)': 'onClick($event)',
    },
    imports: [ServersideutoCompleteComponent, CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, NgClass, MatOption, DynamicFormComponent, TranslateModule, DecimalFormatterPipe]
})
export class BarcodeMappingComponent implements OnInit {

  @Output() selectedBarocde: EventEmitter<any> = new EventEmitter();

  constructor(public _CommonService: CommonService,private _ts: TranslateService, private _Ts: TransferService,
    private _barcodeAutoIncrementService: BarcodAutoGeneratorServiceService,
    private apiServiceProviderService: APIServiceProviderService,
    private router: Router,
    private _Is: InventoryService,
    private _ngZone: NgZone,
    private _MS: MultilanguageService,
    private csharpService: CSharpRequestService,
    private cdRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private GlobalConService: GlobalConversionService,
    private activatedRoute: ActivatedRoute,
    private facadeService: FacadeService,
    private _sp: SpoilageService,
    private _Po: PurchaseOrderService,) 
    {    
      window['barcode'] ={
        zone: this._ngZone,
        ReadBarcodefromCSharp: (value: string) => this.ReadBarcodefromCSharp(value),
        component: this
      };
      const waitTime: number = this._CommonService && this._CommonService.debounceTime ? this._CommonService.debounceTime : 500;
      this.debounceSubscription = this.debounceSub.pipe(debounceTime(waitTime)).subscribe((data) => {
        if (data) {
          this.isSearched = true;
          this.getSearchResults(data);
        }
      });
      this._CommonService.titleOptions = {
        'back': true,
        'pageTitle': 'Barcode Mapping',
        'action': false,
        'innerHeader': true,
        'backFunction': this.back,
        'poRequisition': false,
      };      
     }     

     ReadBarcodefromCSharp(barcode: string) {
      if (barcode?.trim()?.toLowerCase() === 'cancel') {
        return;
      }
      this.IsBarcodeLoading = true;
      this._CommonService.isBarcodeScan = true;
      this.getSearchResults(barcode.toString());
    }
     
  back(event, _this) {
    _this.confirmBack();
  }

  cancel(event){
    this.navigateBack();
  }
  
  navigateBack() {
    if(this.component === 'receiving'){
      const urlExtraParams: NavigationExtras = {
        queryParams: {
          loadedevent: this.facadeService.Receiving.itemsFrom,
          name: this.activatedRoute.snapshot.queryParams.name,
          id: this.activatedRoute.snapshot.queryParams.id,
        }
      }; 
      this.router.navigate(['/receiving/request-list'], urlExtraParams);
    }
    else{
      let pop;
      if(this.component === 'spoilage'){
        pop = this._sp.routeStack.pop();
      }
      else if(this.component === 'transfer'){
        pop = this._Ts.routeStack.pop();
      }
      else if(this.component === 'purchase'){
        pop = this._Po.routeStack.pop();
      }
      else{
        pop = this._Is.reqrouteStack.pop();
      }
    if (pop.split('?').length > 1) {
      const url = this._CommonService.generateParams(pop);
      this.router.navigate([pop.split('?')[0]], url);
    } else {
      this.router.navigate([pop]);
    }
    }
  }
  @ViewChild(ServersideutoCompleteComponent) autoComplete: ServersideutoCompleteComponent;
  public units = ["Each","Ounce","Pound","Gram"];
  public debounceSub = new Subject();
  public componentName: string = 'barcode';
  public functionName: string = myGlobals.CSharpCallBackFunctions.BarcodeReadCallBack;
  public searchSources: SearchHistoryEntity[];
  public searchCollectionData: any[];
  public selectedSearchSourceName = '';
  public selectedSearchSourceId = 0;
  public debounceSubscription: ISubscription;
  recentText: string;
  searchoptionalParams: any = [];
  public Inventory: any[];
  public filteredSearchResult: any = [];
  showOptions = false;
  showButtons = false;
  showButtonsPreviousValue: boolean;
  public IsBarcodeLoading = false;
  input_value = '';
  itemId: number;
  public searchHistoryPostEntity: SearchHistoryPostEntity;
  public loggedInSiteId = 0;
  public loggedInUserId = 0;
  public loggedInUserName = '';
  searchSourceCollection: any = [];
  public inventoryStatusSummary: InventoryStatusSourceDetails[];
  @ViewChild(DynamicFormComponent) forms: DynamicFormComponent;
  unitTypes = [];
  routedFrom: string;
  reqSkip = 0;
  totalData = 0;
  searchText = '';
  isSearched = false;
  public config: FieldConfig[];
  ingredientDetail: any = [];
  showForm = false;
  unitsList = [];
  PostDate:any;
  fromLocationId:number;
  toLocationId:number;
  component:string;
  transType:number;
  standardFBUnitTypes = [1,2,3,4];
  standardRetailUnitTypes = [1,2];


  async ngOnInit() {
    this.config = [       
      {
        type: 'input',
        label: 'Barcode',
        name: 'barcode',
        placeholder: 'Barcode',
        validation: [Validators.required],
        class: '',
        id: 'Barcode',          
      },
      {
        type: 'autocomplete',
        label: 'Unit',
        name: 'unit',
        placeholder: 'Unit',
        options: this.unitsList,
        validation: [Validators.required],
        panelClass: 'unit',
        id: 'unit',
      },
      {
        type: 'number',
        label: 'Pack Size',
        name: 'packsize',
        placeholder: 'Pack Size',            
        validation: [Validators.required],        
        fieldFormatter:"decimal"
      },
      {
        type: 'select',
        label: 'Unit Type',
        name: 'unittype',
        placeholder: 'Unit Type',
        options: this.unitTypes,
        validation: [Validators.required],
        panelClass: 'unit',
        id: 'unittype',
      },
      {
        type: 'textarea',
        label: 'Remarks',
        name: 'remarks',
        placeholder: 'Remarks',
        class: '',
        id: 'remarks',
        maxLengthCount: 128,
        maxLengthHint: true,
        maxLengthText: 'Max 128 Characters'
      },
      {
        type: 'button',
        label: this._ts.instant('common.add'),
        name: 'button',
        class: 'large-button-mobile-confirm confirm-button',
        id: 'confirmText',          
      },
      {
        type: 'button',
        label: this._ts.instant('common.cancel'),
        name: 'button',
        class: 'large-button-mobile-cancel cancel-button',
        id: 'nextBtn',
        function: this.cancel.bind(this),
      },
    ];
    this.getMasterData();   
    await this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.PostDate = params['PostDate'];
        this.fromLocationId = params['FromLocId'];
        this.toLocationId = params['ToLocationId'];
        this.component = params['component'];
        this.transType = params['TransType'];
      }
    });
    this.searchoptionalParams = {
      'placeholder': this._ts.instant('INVENTORY.searchText'),
      'isSearchDropRequired': false, 'barcodeRequired': true, 'searchType': 'text', 'close': false
    }; 
    setTimeout(() => {
      const autoCompleteSearch = document.getElementById('autoCompleteSearch');
      if (autoCompleteSearch) {
        autoCompleteSearch.focus();
      }
    }, 200);
  }

  async confirm(event){
    if(this.GlobalConService.checkValidation(this.forms.form.controls, false)){
      const postParams = {} as IngredientsBarcodeEntity;
      postParams.IngredientsId = this.ingredientDetail?.IngredientId;
      postParams.Barcode = event.barcode;
      postParams.UnitId = this.unitsList.filter(x=> x.value === event.unit)[0]?.id;
      postParams.Conversion = event.packsize;
      postParams.UnitTypeId = this.unitTypes.filter(x=> x.id === parseInt(event.unittype))[0]?.id;
      postParams.Remark = event.remarks;
      const responseData = await this.apiServiceProviderService.inventoryService.PostIngredientsBarcodes(postParams).toPromise();                
      let navigationExtras: NavigationExtras;
      this.ingredientDetail.Units = JSON.stringify(this.ingredientDetail.Units);  
      if(this.component === 'receiving'){
        navigationExtras = {
          queryParams: {          
            'data':JSON.stringify(this.ingredientDetail),               
            loadedevent: this.facadeService.Receiving.itemsFrom,
            name: this.activatedRoute.snapshot.queryParams.name,
            id: this.activatedRoute.snapshot.queryParams.id
          }
        };
      }
      else{
        navigationExtras = {
          queryParams: {          
            'data':this.ingredientDetail,
            'selectedIds': [this.ingredientDetail.Id],
            'eventAction': 'selectedItemClick',
            'routedFrom': 'fromBarcode',   
          }
        };  
      }    
      this.selectedBarocde.emit(navigationExtras);
    }
  }
  showPopUp(headerText, contentText, cancelText, confirmText) {
    const dialogArray = { headerText: headerText, contentText: contentText, cancelText: cancelText, confirmText: confirmText };
    this._CommonService.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent,
      this._CommonService.mobilePopUpProperty
    );
    dialogRef.afterClosed().subscribe((result) => {
      this._CommonService.OpenProcessingPopUp('');
      this._CommonService.closeProcessingPopUp();
    });
  }


  async getloggedInDetails() {
    if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteId.toString())) {
      this.loggedInSiteId = await parseInt(sessionStorage.getItem(appApiResources.loggedInSiteId.toString()));
    }
    if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserId.toString())) {
      this.loggedInUserId = await parseInt(sessionStorage.getItem(appApiResources.loggedInUserId.toString()));
    }
    if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserName.toString())) {
      this.loggedInUserName = await sessionStorage.getItem(appApiResources.loggedInUserName.toString());
    }
  }

  async getMasterData() {
    try {
      await this.getSearchSource();
      await this.getloggedInDetails();
    } catch (error) {
    }
  }

  async getUnits(isRetail = false){
    const filterQuery1 = '$filter=IsActive eq true&$orderby=id asc';
    const unitsResult = await this.apiServiceProviderService.inventoryService.getUnitList(filterQuery1);   
    const filterQuery2 = '$orderby=id asc';    
    const unittypeResult = await this.apiServiceProviderService.inventoryService.GetUnitTypes(filterQuery2);    
    this.unitTypes = [];
    unitsResult?.value?.forEach(element => {
      this.unitsList.push({
        'id': element.Id,
        'value': element.Name,
      });
    });
    const unitList = isRetail ? this.standardRetailUnitTypes : this.standardFBUnitTypes;
    unittypeResult?.value?.forEach(element => {
      if(unitList.indexOf(element.Id) != -1){
        this.unitTypes.push({
          'id': element.Id,
          'value': element.Name,
        });
      }
      
    });
    this.config.forEach(field => {
      if(field.name === 'unittype') {
        field.options = this.unitTypes;
      }
    });
    this.config = [... this.config];
    this.forms.form.patchValue({
      inventoryName : this.ingredientDetail?.Name,
      units : this.unitsList,
      unittype: this.unitTypes,
      barcode: this._CommonService.userBarCode
    })
  }
  /**
  * @function getSearchSource()
   * @description Provide search source data to bind dropdownlist
   * */
  async getSearchSource() {
    this.searchSources = (SearchSource as any).default;
    if (this.searchSources && this.searchSources.length > 0) {
      this.searchSources = this.searchSources.filter(x => x.SourceName === appApiResources.SearchSourceType.SearchByInventory
        || x.SourceName === appApiResources.SearchSourceType.SearchByPackage);
      if (this.searchSources && this.searchSources.length > 0) {
        this.searchSourceCollection = {
          'defaultItem': this.searchSources.find(x => x.SourceName === appApiResources.SearchSourceType.SearchByInventory).SourceName,
          'searchSources': this.searchSources

        };
        if (this.routedFrom !== 'fromPackage') {
          this._CommonService.selectedDropDown = this.searchSourceCollection.defaultItem;
        }

        if (this._CommonService && this._CommonService.selectedDropDown) {
          this.selectedSearchSourceName = this.searchSources.find(x => x.SourceName === this._CommonService.selectedDropDown).SourceName;
          this.selectedSearchSourceId = this.searchSources.find(x => x.SourceName === this._CommonService.selectedDropDown).SourceId;
        } else {
          this.selectedSearchSourceName = this.searchSources.find(
            x => x.SourceName === appApiResources.SearchSourceType.SearchByInventory).SourceName;
          this.selectedSearchSourceId = this.searchSources.find(
            x => x.SourceName === appApiResources.SearchSourceType.SearchByInventory).SourceId;
        }
      }
    }
  }

  inventoryResult(event: any) {
    this.debounceSub.next(event);
  }

  clearSearchData(isForceClear: boolean, searchValue: string) {
    if (isForceClear === true) {
      //  this.searchValue = '';
      this.Inventory = []; // Clear
      this.filteredSearchResult = []; // Clear
      this.showOptions = false;

    }
    if (searchValue.length === 0) {
      this.Inventory = []; // Clear
      this.filteredSearchResult = []; // Clear
      this.showOptions = false;

    }
  }
  /***
  * @function  selectedListitem(e)()
  * @params object;
  * @description Pass the data to ( this._Is.selectedItem = e );
  * @output Array
  */
   selectedListitem(e: any) {
    if (this.searchSources) {
      this.searchCollectionData = [];
      const sourceIndex = this.searchSources.findIndex(x => x.SourceName === e);
      this.selectedSearchSourceName = e;
      this.selectedSearchSourceId = this.searchSources[sourceIndex].SourceId;
      this._CommonService.selectedDropDown = e;
      this.clearSearchData(true, '');
      if (this.selectedSearchSourceId > 0 /* && (this.tableData.tableData === false || this.tableData.tableData.length <= 0) */) {
        if (this._CommonService.isonlineStatus) {
        }
      }
      switch (this.selectedSearchSourceName) {
        case appApiResources.SearchSourceType.SearchByInventory:
          this.recentText = this._ts.instant('common.items');
          this.searchoptionalParams.placeholder = this._ts.instant('INVENTORY.searchText');
          break;

        case appApiResources.SearchSourceType.SearchByPackage:
          this.recentText = this._ts.instant('common.packages');
          this.searchoptionalParams.placeholder = this._ts.instant('common.searchByName');
          break;

        case appApiResources.SearchSourceType.SearchByClass:
          this.searchoptionalParams.placeholder = this._ts.instant('common.searchByName');
          this.recentText = this._ts.instant('common.classes');
          break;

        case appApiResources.SearchSourceType.SearchByType:
          this.searchoptionalParams.placeholder = this._ts.instant('common.searchByName');
          this.recentText = this._ts.instant('common.types');
          break;
      }
    }
  }
  autocompleteFO() {
    this.clearSearchData(true,'');
    this.showButtons = this.showButtonsPreviousValue;
  }
  autocompleteFI() {
    this.showButtonsPreviousValue = this.showButtons;
    this.showButtons = false;
  }
  searchPasteData(event: any) {
    this.IsBarcodeLoading = true;
    this.input_value = event.toString();
    this.getSearchResults(event);
  }

  getSearchResults(event: any) {
    this.searchText = event;
    if (this._CommonService.isonlineStatus) {
      this.filteredSearchResult = [];
      this.getSearchData(event);
    } else {
      this.getSearchDataFromLocal(event);
    }
  }

  searchInventory(event: any) {
    this.debounceSub.next(event);
  }

  async getSearchData(searchValue: string) {
    switch (this.selectedSearchSourceName) {
      case appApiResources.SearchSourceType.SearchByInventory:
        if (searchValue.length >= Number(this._CommonService.searchChar)) {
          const InventoryLookUp = {} as LookupConfigurationV2;
          InventoryLookUp.ClassIds = [];
          InventoryLookUp.FromLocationIds = [Number(this.fromLocationId)];
          InventoryLookUp.ToLocationIds = this.toLocationId ? [this.toLocationId] : [];
          InventoryLookUp.PackageIds = [];
          InventoryLookUp.TransactionTypeIds = [Number(this.transType)];
          InventoryLookUp.SearchText = searchValue;
          InventoryLookUp.TypeIds = [];
          InventoryLookUp.FetchAll = false;
          InventoryLookUp.Skip = this.reqSkip;
          InventoryLookUp.Take = myGlobals.InventoryLookUpTake;
          this.apiServiceProviderService.inventoryService.GetInventoryLookUpV2(InventoryLookUp)
            .subscribe((result: InventoryLookupCollection) => {
              this.searchCollectionData = result.ResultData as Array<any>;
              this.totalData = result.TotalCount;
              this.getSearchFilterData(searchValue);
            });
        }
        if (searchValue.length < Number(this._CommonService.searchChar)) {
          this.showOptions = false;
          this.clearSearchData(true, searchValue);
        }
        break;
      case appApiResources.SearchSourceType.SearchByPackage:
        if (searchValue.length > 0) {
          this.GetSearchClassesTypesPackages(SearchByCategoryId.Packages, searchValue);
        }
        
        break;

      case appApiResources.SearchSourceType.SearchByClass:
        if (searchValue.length > 0) {
          this.GetSearchClassesTypesPackages(SearchByCategoryId.Classes, searchValue);
        }
        break;

      case appApiResources.SearchSourceType.SearchByType:
        if (searchValue.length > 0) {
          this.GetSearchClassesTypesPackages(SearchByCategoryId.Types, searchValue);
        }
        break;

    }
  }

  GetSearchClassesTypesPackages(searchByCategoryId: number, searchValue: string){
    try{
      const requestParams = {
        ...this._CommonService.constructClassesTypesPackagesPayload(
          {
            Skip: this.reqSkip,
            searchText: searchValue,
            orderByColumn: null,
            SearchByCategoryId: searchByCategoryId,
            FromLocationId: Number(this.fromLocationId) || 0,
            ToLocationId: Number(this.toLocationId) || 0
          })
      }
      this.apiServiceProviderService.inventoryService.GetClassesTypesPackages(requestParams).subscribe(result => {
        const TypeData = result[0] as Array<any>;
        if (TypeData.hasOwnProperty('ResultData') && TypeData['ResultData'].length > 0) {
          this.searchCollectionData = TypeData['ResultData'];
          this.totalData = TypeData['ResultData'].length;
        };
        this.getSearchFilterData(searchValue);
        this.showOptions = true;
      });
        if (searchValue.length === 0) {
          this.showOptions = false;
          this.clearSearchData(true, searchValue);
        }
    } catch (error) {
      console.log(error, 'Get Search Classes Types Packages')
    }
  }

  getSearchDataFromLocal(searchValue: string) {
    this.input_value = searchValue;
    if (searchValue.length > 0) {
      // if (this.searchCollectionData == undefined || this.searchCollectionData.length == 0) {
      switch (this.selectedSearchSourceName) {
        case appApiResources.SearchSourceType.SearchByInventory:
          if (searchValue.length >= Number(this._CommonService.searchChar)) {
            this._CommonService.OpenProcessingPopUp("");
            const sourceObj = {
              componentName: appApiResources.ComponentNameReferences.InventoryList,
              funcName: appApiResources.CSharpCallBackFunctions.GetSearchDataCallBack,
              Action: myGlobals.cSharpActionName.BindSearchvalue,
              searchValue: this.input_value, siteId: this.loggedInSiteId, userId: this.loggedInUserId,
            };
            this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetInventory, sourceObj);
          }
          break;
        case appApiResources.SearchSourceType.SearchByPackage:
          this._CommonService.OpenProcessingPopUp("");
          const packListObj = {
            componentName: appApiResources.ComponentNameReferences.InventoryList,
            funcName: appApiResources.CSharpCallBackFunctions.GetPackagesCallBack,
            Action: myGlobals.cSharpActionName.BindPackages,
            packType: appApiResources.PackageType.Inventory,
            siteId: this.loggedInSiteId, userId: this.loggedInUserId
          };
          this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSources, packListObj);
          break;
        case appApiResources.SearchSourceType.SearchByClass:
          this._CommonService.OpenProcessingPopUp("");
          const classListObj = {
            componentName: appApiResources.ComponentNameReferences.InventoryList,
            funcName: appApiResources.CSharpCallBackFunctions.GetSearchDataCallBack,
            Action: myGlobals.cSharpActionName.BindClass,
            userId: this.loggedInUserId
          };
          this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSources, classListObj);
          break;
        case appApiResources.SearchSourceType.SearchByType:
          this._CommonService.OpenProcessingPopUp("");
          const typeListObj = {
            componentName: appApiResources.ComponentNameReferences.InventoryList,
            funcName: appApiResources.CSharpCallBackFunctions.GetSearchDataCallBack,
            Action: myGlobals.cSharpActionName.BindTypes,
            userId: this.loggedInUserId
          };
          this.csharpService.RequestGETCSharp(appApiResources.cSharpURLs.GetSources, typeListObj);
          break;
      }
    }
    if (searchValue.length < Number(this._CommonService.searchChar)) {
      this.showOptions = false;
      this.clearSearchData(true, searchValue);
    }
  }

  getSearchFilterData(searchValue: string) {
    switch (this.selectedSearchSourceName) {
      case appApiResources.SearchSourceType.SearchByInventory:
        if (searchValue.length >= 0 && this.searchCollectionData !== undefined && this.searchCollectionData.length > 0) {
          if (this.IsBarcodeLoading) {
            this.searchCollectionData.forEach(option => {
              const elementResult = (option.hasOwnProperty('Barcode') && option.Barcode !== null) ? option.Barcode : option.Number;
              const x = elementResult.split(',');
              option.FullSearchText = (option.Name ? option.Name : '') + ' - #'
                + (option.Number ? option.Number : '') + (option.BarCode ? ' - ' + option.BarCode : '') + (option.Description ? ' - ' + option.Description : '')
              this.filteredSearchResult.push(option);
              this.filteredSearchResult = [...this.filteredSearchResult]
            });
          } else {
            this.filteredSearchResult = this.searchCollectionData.filter(option => {
              return (

                
                option.Name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 ||
                option.Number.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 ||
                (option.IngredientsBarCodes == undefined ? option.Barcode?.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 : option?.IngredientsBarCodes.filter(x => x.Barcode?.indexOf(searchValue.toLowerCase()) >= 0).length > 0) ||
                option.Description.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
              );
            });
            this.filteredSearchResult.forEach(option => {
              option.FullSearchText = (option.Name ? option.Name : '') + ' - #'
                + (option.Number ? option.Number : '') + (option?.IngredientsBarCodes && option?.IngredientsBarCodes[0]
                  && option?.IngredientsBarCodes[0].Barcode ? ' - ' + option?.IngredientsBarCodes[0].Barcode :
                  (option.BarCode ? ' - ' + option.BarCode : ''))  //offline
                + (option.Description ? ' - ' + option.Description : '')
            });
          }
        } else {
          this.clearSearchData(true, searchValue);
        }
        break;

      case appApiResources.SearchSourceType.SearchByPackage:
      case appApiResources.SearchSourceType.SearchByClass:
      case appApiResources.SearchSourceType.SearchByType:
        if (searchValue.length > 0 && this.searchCollectionData !== undefined && this.searchCollectionData.length > 0) {
          this.filteredSearchResult = this.searchCollectionData;
          if(!this._CommonService.isonlineStatus && searchValue?.trim() !== '%') {
          this.filteredSearchResult = this.searchCollectionData.filter(option => {
            return (
              option.Name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
            );
          });
        }
        this.filteredSearchResult.forEach(option => {
          option.FullSearchText = option.Name;
        });
        } else {
          this.clearSearchData(true, searchValue);
        }
        break;

    }
    this.showOptions = true;
    if (this.filteredSearchResult.length === 0) {
      if (this.IsBarcodeLoading) {
        this._barcodeAutoIncrementService.onAudioPlay(false);
        this.IsBarcodeLoading = false;
        this.autoComplete.assignTextValueFromReader(searchValue);
      }
    }
    // if (this.filteredSearchResult.length > 0) {
    //   if (this.IsBarcodeLoading) {
    //     this._barcodeAutoIncrementService.onAudioPlay(true);
    //     this.showOptions = false;
    //     this.onSearchItemClick(this.filteredSearchResult[0], true);
    //     if (this._CommonService.barcodeAutoIncrement !== 'true') {
    //       this.IsBarcodeLoading = false;
    //     }
    //   }
    // }
    this.clearSearchData(false, searchValue);    
  }

  async getInventoryLookupById(id : any) {
    const InventoryLookUp = {} as InventoryLookUpPost;
    InventoryLookUp.PostDate = this.PostDate;
    InventoryLookUp.ClassIds = [];
    InventoryLookUp.FromLocationId = Number(this.fromLocationId);
    InventoryLookUp.PackageIds = [];
    InventoryLookUp.TransType = Number(this.transType);
    InventoryLookUp.searchText = '';
    InventoryLookUp.TypeIds = [];
    InventoryLookUp.options = '';
    InventoryLookUp.Id = id;
    InventoryLookUp.selectedIngredients = [id];
    InventoryLookUp.flgSearch = false;
    await this.apiServiceProviderService.inventoryService.GetInventoryLookUp(InventoryLookUp).subscribe((response: InventoryLookupCollection) => {
      if (response.Data.ent.ResultData && response.Data.ent.ResultData.length > 0) {
        this.ingredientDetail =  response.Data.ent.ResultData[0];
        this.ingredientDetail.Units = JSON.parse(response.Data.ent.ResultData[0].Units);
        this._CommonService.isFocusOut = true;
        const isretail = response.Data.ent.ResultData[0].DivisionId === 2 ? true : false;
        this.getUnits(isretail);
      }
    });
  }
  
  async onSearchItemClick(item: any, isSearch: boolean) {    
    this.getInventoryLookupById(item.Id);
    this.ingredientDetail = item;
    this.showForm = true;
    this.clearSearchData(true, '');
    setTimeout(() => {
    this.forms.form.patchValue({
      inventoryName : this.ingredientDetail?.Name,
      barcode: this._CommonService.userBarCode
    })
    let addbtn = document.getElementsByClassName('large-button-mobile-confirm')[0] as HTMLElement;
    let cancelbtn = document.getElementsByClassName('large-button-mobile-cancel')[0] as HTMLElement;
    addbtn.style.width = '100%';
    cancelbtn.style.width = '100%'
   }, 100);
  }


  @HostListener('scroll', ['$event'])
  onScroll($event) {
    this._CommonService.scrollEvent($event);
  }
  selectedData: any = [];
  closePopOver() {  
    this.selectedData = [];
  }

  fetchData(event) {
    if (Math.round(event.target.offsetHeight + event.target.scrollTop) === event.target.scrollHeight) {
      if (this.filteredSearchResult.length < this.totalData) {
        this.reqSkip += 100;
        this.isSearched = false;
        if (this._CommonService.isonlineStatus) {
          this.getSearchData(this.searchText);
        }
        else {
          this.getSearchDataFromLocal(this.searchText);
        }
      }
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    console.log(event);
    if (event.key === 'Enter') {
      setTimeout(() => {
        const autoCompleteSearch = document.getElementById('autoCompleteSearch');
        if (autoCompleteSearch) {
          autoCompleteSearch.focus();
        }
      }, 200);
    }
  }

  onClick(event) {
    console.log('event ', event);
    if (event.target.ClassName !== 'search-name') {
      this.showOptions = false;
      this.autoComplete.clearData();
    }
  }

  ngOnDestroy(){
    if (this.debounceSubscription) {
      this.debounceSubscription.unsubscribe();
    }
    this._CommonService.userBarCode = '';
    this.cdRef.detach();
  }
   
}
